<template>
 <v-dialog  width="1000px" :value="show">
    <v-card height="535px">
      <v-card-text class="h-100 pb-0">
        <v-layout column wrap h-100>
          <v-flex>
            <vue-perfect-scrollbar >
              <v-tabs ref="tabs" grow 
                v-model="active"
                color="white" class="dataScroll" dark 
                slider-color="k-orange-linear--text"
              >
                <v-tab class="black--text">
                  Grafica
                </v-tab>
                <v-tab ripple class="black--text">
                  Tabla
                </v-tab>
                <v-tab-item>
                  <stacked-area v-if="show" height="400px" :data="data" dateFormat="dd/MM/yyyy"/>
                </v-tab-item>
                <v-tab-item>
                  <v-data-table
                      :headers="headers"
                      :items="data"
                      hide-actions
                      no-data-text="No se encontraron registros"
                      class="bordered mx-4 b-borders">
                    <template slot="headerCell" slot-scope="props" class="k-orange-linear">
                      <span slot="activator">
                        {{ props.header.text }}
                      </span>
                    </template>
                    <template  slot="items" slot-scope="props">
                      <td>
                        {{ props.item.date }}
                      </td>
                      <td>
                        {{ new Intl.NumberFormat('es-VE').format(props.item.totals) }}
                      </td>
                      <td>
                        {{ new Intl.NumberFormat('es-VE').format(props.item.reached) }}
                      </td>
                      <td>
                        {{ new Intl.NumberFormat('es-VE').format(props.item.contacted) }}
                      </td>
                      <td>
                        {{ new Intl.NumberFormat('es-VE').format(props.item.promise) }}
                      </td>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </vue-perfect-scrollbar>
          </v-flex>
          <v-flex>
            <v-layout class="h-100 ma-0" justify-end align-end>
              <v-btn flat  @click="$emit('close')">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import StackedArea from './StackedArea';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    StackedArea,
  },
  data() {
    return {
      active: null,
      cancelToken: this.axios.CancelToken.source(),
      headers: [
        {
          text: 'Fecha',
          align: 'left',
          value: 'day',
        },
        {
          text: 'Gestionados',
          align: 'left',
          value: 'total',
        },
        {
          text: 'Contactados',
          align: 'left',
          value: 'contacted',
        },
        {
          text: 'Contacto útil',
          align: 'left',
          value: 'reached',
        },
        {
          text: 'Compromiso',
          align: 'left',
          value: 'promise',
        },
      ],
      data: [],
    };
  },
  methods: {
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    search() {
      this.cancelRequest();
      this.data = [];
      this.axios.get('efectivity/report/perDay', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
        },
      }).then((res) => {
        const data = res.data.totals;
        let month = this.filters.date.split('-');
        month = `${month[0]}${month[1]}`;
        for (let i = 0; i < 31; i += 1) {
          let date = `${month}${i < 9 ? '0' : ''}${i + 1}`;
          const position = data.find(x => x.date === Number(date)) || {};
          date = moment(date, 'YYYYMMDD').format('DD/MM/YYYY');
          if (date !== 'Invalid date') {
            this.$set(this.data, i, {
              date,
              totals: Number(position.total) || 0,
              reached: Number(position.contacted) || 0,
              contacted: Number(position.reached) || 0,
              promise: Number(position.promise) || 0,
            });
          }
        }
      }).catch(() => {});
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(show) {
        this.active = '0';
        if (show) {
          this.search();
        } else {
          this.cancelRequest();
        }
      },
    },
  },
};
</script>
<style scoped>
.dataScroll {
  max-height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine/Historic.vue